.downloadsTable{}

.downloadsTable td, .downloadsTable th{
    border-bottom: 1px solid rgba(0, 0, 0, .38);
    padding: 4px 8px;
    font-size: 14px;
}

.downloadsTable thead tr:first-child{
    border-radius: 8px 8px 0 0;
    outline: 1px solid rgba(0, 0, 0, .38);
}

.downloadsTable td:first-child, .downloadsTable th:first-child{
    padding-left: 16px;
}

.downloadsTable tr td:first-child{
    border-left: 1px solid rgba(0, 0, 0, .38);
}
.downloadsTable tr td:last-child{
    border-right: 1px solid rgba(0, 0, 0, .38);
}

.downloadsTable tr th{
    background-color: #505050;
    color: white;
    font-weight: 400;
}

.downloadsTable tr th:first-child{
    border-radius: 8px 0 0 0;
}

.downloadsTable tr th:last-child{
    border-radius: 0 8px 0 0;
}


.downloadsTable tr td:last-child{
    padding-right: 0;
}

.downloadsTable tr:hover td{
    background-color: #e6e8e9;
}

@media screen and (max-width: 988px) {
    .downloadsTable{
        overflow-x: auto;
    }
}